export const COOKIE_CONSENT_CATEGORY = {
  analytics: 'analytics',
  externalServices: 'externalServices',
  marketing: 'marketing',
  necessary: 'necessary',
} as const

export const COOKIE_CONSENT_SERVICE = {
  crescoreChatbot: 'crescoreChatbot',
  googleAds: 'googleAds',
  googleAnalytics: 'googleAnalytics',
  metaPixel: 'metaPixel',
  salesforceBooking: 'salesforceBooking',
} as const

export const COOKIE_CONSENT_COOKIE_NAME = 'nw_cookie_consent'
export const COOKIE_CONSENT_EXPIRES_AFTER_DAYS = 182
export const COOKIE_CONSENT_REVISION = 8

export type CookieConsentCategory =
  (typeof COOKIE_CONSENT_CATEGORY)[keyof typeof COOKIE_CONSENT_CATEGORY]

export type CookieConsentService =
  (typeof COOKIE_CONSENT_SERVICE)[keyof typeof COOKIE_CONSENT_SERVICE]
